import type * as lazyFullOption from './lazyFullOption';
import {
    optionTitle_templates,
    optionSearchTerms_templates,
} from './TemplatesOption.locstring.json';
import type { LazyOption } from 'owa-options-core';
import { createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';

const lazyFullModule: LazyModule<typeof lazyFullOption> = new LazyModule<typeof lazyFullOption>(
    () => import('./lazyFullOption'),
    {
        name: 'TemplatesOption',
    }
);

const TemplatesOption: LazyOption = createLazyOption(
    {
        key: 'mailTemplatesOption',
        titleStringKey: optionTitle_templates,
        isTitleHidden: () => true,
        searchTermsStringKey: optionSearchTerms_templates,
        copilotSettingKey: 'templates',
    },
    lazyFullModule,
    m => m.default
);

export default TemplatesOption;
